import { Location } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription } from 'rxjs';
import { GeneralConstants } from 'src/app/constants/GeneralConstants';
import { AggReqObjectHandlerService } from 'src/app/_services/agg-req-object-handler.service';
import { AggregationService } from 'src/app/_services/aggregation.service';
import { CompanyInsightsService, ExportPayload, ExportRequest } from 'src/app/_services/company-insights.service';
import { FilterDataHandlerService } from 'src/app/_services/filter-data-handler.service';
import { HashService } from 'src/app/_services/hash.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { TalentInsightsReqHandlerService } from 'src/app/_services/talent-insights-req-handler.service';

@Component({
  selector: 'app-titles-tab',
  templateUrl: './titles-tab.component.html',
  styleUrls: ['./titles-tab.component.scss']
})
export class TitlesTabComponent implements OnInit {
  
  constructor(private personSearchService: PersonSearchService, private location: Location, private companyinsightsService: CompanyInsightsService, private localStorageService: LocalStorageService,
    private filterDataHandlerService: FilterDataHandlerService, private talentInsightsReqHandlerService: TalentInsightsReqHandlerService,
    private aggReqObjectHandlerService: AggReqObjectHandlerService, private aggService: AggregationService, private hashService: HashService) { }
  companyDetails: any;
  currentCompanyName: any;
  titles: any = [];
  functions: any = [];
  functionStartIndex: number = 0;
  jobTitleStartIndex: number = 0;
  totalFunctionResultCount: number = 0;
  jobTitleAggregatesCount: number = 50;
  jobTitleIsViewMore: boolean = true;
  functionAggregatesCount: number = 50;
  functionIsViewMore: boolean = true;
  showTitleLoader: boolean = true;
  alternatecompanyNames: any[] = [];
  
  /**total result count for titles */
  totalTitleResultCount = 0;

  /** start index in title page */
  startTitle: number = 0;
  /**End index in title page */
  endTitle: number = 10;
  /**Number of title items on each of page */
  pageSizeTitle:number = 10;
  /**Current page number of titles */
  currentPageTitle: number = 1;
  /**Total items in titles page */
  totalCountTitle = 0;

  /** start index in function page */
  startFunction: number = 0;
  /**End index in function page */
  endFunction: number = 5;
  /**Number of items on each of function page */
  pageSizeFunction:number = 5;
  /**Current page number in function */
  currentPageFunction: number = 1;
  /**Total items in function page*/
  totalCountFunction = 0;
  titlessubscription: Subscription;
  titleemptystate: Boolean = false;
  functionemptystate: Boolean = false;
  titlesdata: any;
  displayedColumns: string[] = ['key', 'doc_count', 'graph', 'avg_tenure'];
  functionsdata: any
  displayedfunctionsColumns: string[] = ['key', 'doc_count', '%total','median_tenure'];
  @ViewChild(MatSort) titlesort: MatSort;
  @ViewChild('functionsort') functionsort = new MatSort();
  titlesortdata: any;
  functionsortdata: any;
  /** Subscription var */
  subscriptions: Array<Subscription> = [];
  companyinsightsFilter: any = {};
  jobtitlesdata: any = [];
  titlesdataAI: any;
  functionsaidata: any = []

  insightsExportSubscription: Subscription = null;

  ngOnInit(): void {
    // this.titlessubscription = this.personSearchService.companyDetail.subscribe((response) => {
    //   this.companyDetails = response;
    //   this.currentCompanyName  = this.companyDetails.name;
    //   this.alternatecompanyNames = this.companyDetails.alternative_names && this.companyDetails.alternative_names.length > 0 ? this.companyDetails.alternative_names.concat([this.currentCompanyName]): [this.currentCompanyName];

    //   this.startTitle = 0;
    //   this.endTitle = 10;
    //   this.currentPageTitle = 1;

    //   this.startFunction = 0;
    //   this.endFunction = 5;
    //   this.currentPageFunction = 1;
      
    //   this.getTitles();
    //   this.getFunction();
    // });
    this.startTitle = 0;
    this.endTitle = 10;
    this.currentPageTitle = 1;
    this.startFunction = 0;
    this.endFunction = 5;
    this.currentPageFunction = 1;
    this.setCompanyDetails();
    this.fetchPageData();
    /**Fetch filter data after applying filters */
    const filterMethodEvent = this.filterDataHandlerService.filterMethodEvent.subscribe(_methodDetails => this.fetchPageData());
    this.subscriptions.push(filterMethodEvent);

    // subscribe to insights-export subject for processing request from parent
    this.insightsExportSubscription = this.companyinsightsService.insightsExportRequestEvent.subscribe((requestData: ExportRequest) => {
      if(requestData && requestData.type === 'SIGNAL') {
        this.shareDataForInsightsExport(requestData);
      }
    });
    this.subscriptions.push(this.insightsExportSubscription);
  }

  setCompanyDetails() {
    this.companyDetails = this.companyinsightsService.fetchCompanyData;
    this.currentCompanyName = this?.companyDetails?.name;
    this.alternatecompanyNames = this.companyDetails?.alternative_names?.length > 0 ? this.companyDetails.alternative_names.concat([this.currentCompanyName]) : [this.currentCompanyName];
  }

  fetchPageData() {
    this.getTitles();
    this.getFunction();
    this.personSearchService.setCompanyInsightsFilterAI(this.companyDetails);

  }

  getTitles() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "current_jobtitle-current_tenure_median";
    aggReq.aggregatescount = this.jobTitleAggregatesCount;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    aggReq.companies = this.alternatecompanyNames;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    this.companyinsightsService.getTotalCompanyaggs(aggReq).subscribe((response) => {
      const tempData = response.data.aggregations['current_jobtitle-current_tenure_median'];
      this.totalTitleResultCount = response.data.totalresultscount;
      tempData.map(res=>{
        res.avg_tenure = res.current_tenure_median.value;
        return res;
      });
      this.titlesortdata = tempData;
      this.gettitlesdataai(this.titlesortdata, 'jobtitles')
      this.totalCountTitle = tempData.length;
      this.titles = tempData.slice(this.startTitle, this.endTitle);
    //  this.titlesdata =  new MatTableDataSource(this.titles);

      this.showTitleLoader = false;
      this.titleemptystate = true;
      this.manualjobtitleSort();
    });
  }

  getFunction() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "current_function-current_tenure_median";
    aggReq.aggregatescount = this.functionAggregatesCount;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    aggReq.companies = this.alternatecompanyNames;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    this.companyinsightsService.getTotalCompanyaggs(aggReq).subscribe((response) => {
      this.totalFunctionResultCount = response.data.totalresultscount;
      const tempData = response.data.aggregations['current_function-current_tenure_median'];
      tempData.map(res=>{
        res.median_tenure = res.current_tenure_median.value;
        return res;
      });
      this.functionsortdata = tempData;
      this.gettitlesdataai(this.functionsortdata, 'functions')
 //     this.functions = tempData.slice(this.startFunction, this.endFunction);
      this.totalCountFunction = tempData.length;
   //   this.functionsdata = new MatTableDataSource(this.functions)
      this.functionemptystate = true;
      this.manualfunctionsort();
    });
  }

  /**
 * Function set the start and end of aggreggate data according to page number in title container
 * @param index page number in pagination
 */
  setPageTitles(index: number) {
    this.startTitle = (index - 1) * this.pageSizeTitle;
    this.endTitle = this.startTitle + this.pageSizeTitle;
    this.currentPageTitle = index;
    if (this.jobTitleAggregatesCount / this.pageSizeTitle <= index){
      this.jobTitleAggregatesCount = this.jobTitleAggregatesCount + 10;
      this.getTitles();
    }
    else{
      this.manualjobtitleSort();
    }
  }

  /**
* Function set the start and end of aggreggate data according to page number in title container
* @param index page number in pagination
*/
  setPageFunction(index: number) {
    this.startFunction = (index - 1) * this.pageSizeFunction;
    this.endFunction = this.startFunction + this.pageSizeFunction;
    this.currentPageFunction = index;
    if (this.functionAggregatesCount / this.pageSizeFunction <= index){
      this.functionAggregatesCount = this.functionAggregatesCount + this.pageSizeFunction;
      this.getFunction();
    }
    else{
      this.manualfunctionsort();
    }
  }

  getTitlePercentage(value){
    return ((value/ this.totalTitleResultCount) * 100).toFixed(2);
  }

  getFunctionPercentage(value) {
    return ((value/ this.totalFunctionResultCount) * 100).toFixed(2);
  }

  cleanCompanyName(companyName: string): string {
    return companyName.replace(/_/g, ' ');
  }

  /**
   * destroy subscriptions of filters
   */
   ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  manualjobtitleSort() {
    this.reSortjobtitleArray(this.titlesort);
  }

  private reSortjobtitleArray(sort: MatSort) {
    const data = this.titlesortdata;
    if (!sort || !sort.active || sort.direction === '') {
      this.titles = data.slice(this.startTitle, this.endTitle);
      this.titlesdata =  new MatTableDataSource(this.titles);
      return;
    }

    this.titlesortdata = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'doc_count': return this.compare(a.doc_count, b.doc_count, isAsc);
        case 'graph': return this.compare(a.doc_count, b.doc_count, isAsc);
        case 'avg_tenure': return this.compare(a.avg_tenure, b.avg_tenure, isAsc);

        default: return 0;
      }
    });
    this.titles = this.titlesortdata.slice(this.startTitle, this.endTitle);
    this.titlesdata =  new MatTableDataSource(this.titles);
  }

  private compare(a: number, b: number, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  manualfunctionsort() {
    this.reSortfunctionArray(this.functionsort);
  }

  reSortfunctionArray(sort) {
    const data = this.functionsortdata;
    if (!sort || !sort.active || sort.direction === '') {
      this.functions = data.slice(this.startFunction, this.endFunction);
      this.functionsdata = new MatTableDataSource(this.functions)
      return;
    }

    this.functionsortdata = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'doc_count': return this.compare(a.doc_count, b.doc_count, isAsc);
        case '%total': return this.compare(a.doc_count, b.doc_count, isAsc);
        case 'median_tenure': return this.compare(a.median_tenure, b.median_tenure, isAsc);
        default: return 0;
      }
    });
    this.functions = this.functionsortdata.slice(this.startFunction, this.endFunction);
    this.functionsdata = new MatTableDataSource(this.functions)
  }

  /**
   * Handel Redirection to person search listing
   * @param type
   * @param key
   */
  handelRedirection(type: string, key: string) {
    const additionalFilters = {};
    switch(type) {
      case 'jobtitle': additionalFilters['mandatoryjobtitles'] = [key]; break;
      case 'functions': additionalFilters['mandatoryfunctions'] = [key]; break;
    }

    this.companyinsightsFilter['additionalFilters'] = additionalFilters;
    this.companyinsightsFilter['name'] = this?.companyDetails?.name;
    this.companyinsightsFilter['alternative_names'] = this.companyDetails?.alternative_names?.length > 0 ? this.companyDetails.alternative_names.concat([this.currentCompanyName]): [this.currentCompanyName];
    const uniqueHash = this.hashService.generateUniqueHash();
    this.talentInsightsReqHandlerService.setSessionDataForCompanyInsightsRedirection(uniqueHash, this.companyinsightsFilter);
    const requestObject = this.aggService.getRequestWithFilters();
    const url = `/person/search/listing?redirectSource=company-insights&${GeneralConstants.LS_KEYS.UNIQUE_HASH_COMPANY}=${uniqueHash}&keyword=${requestObject.booleanquery!= '*' ? requestObject.booleanquery: ''}`;    window.open(url, "_blank");
  }

  getonedigitnumber(number) {
    return number.toFixed(1);
  }

  private getFormattedTenure(tenure: number) {
    const totalYears = Math.floor(tenure);
    const totalMonths = Math.round((tenure - totalYears) * 12);
    if (totalYears > 0 && totalMonths > 0) {
      return `${totalYears} ${totalYears == 1 ? 'Yr' : 'Yrs'} ${totalMonths} Mths`;
    } else if (totalYears > 0 && totalMonths == 0) {
      return `${totalYears} ${totalYears == 1 ? 'Yr' : 'Yrs'}`;
    } else if (totalYears == 0 && totalMonths > 0) {
      return `${totalMonths} Mths`;
    } else {
      return '';
    }
  }

  gettitlesdataai(data, type) {
    if(type == 'jobtitles') {
      this.jobtitlesdata = data.map(x=>{
        let res: any ={};
        res['Job Titles'] = x.key;
        res['Talent Count'] = x.doc_count;
        res['% of Total'] = this.getTitlePercentage(x.doc_count)+'%';
        res['Median Tenure'] = Math.round(x.avg_tenure * 100) / 100 + 'yrs';
        return res;
      })
    } 
    if(type == 'functions') {
      this.functionsaidata = data.map(x=>{
        let res: any ={};
        res['Role'] = x.key;
        res['Talent Count'] = x.doc_count;
        res['% of Total'] = this.getFunctionPercentage(x.doc_count)+'%';
        res['Median Tenure'] = Math.round(x.median_tenure * 100) / 100 + 'yrs';
        return res;
      })
    }
   
    this.titlesdataAI = {
      jobtitles: this.jobtitlesdata,
      functions: this.functionsaidata

    } 
    if(this.jobtitlesdata.length == 0 && this.functionsaidata.length == 0)
      this.titlesdataAI = null
  }

  /**
   * Share data with parent to initiate insights-export
   * @param requestData 
   */
  shareDataForInsightsExport(requestData: ExportRequest) {
    if(requestData?.data?.currentTab !== 'titles') return;

    const payloadForInsightsExport: ExportPayload = {
      tab: 'titles',
      companydetails: this.companyDetails,
      totalresultcount: this.totalTitleResultCount,
      titles: this.titlesortdata,
      functions: this.functionsortdata
    }
    this.companyinsightsService.sendInsightsExportData(payloadForInsightsExport);
  }
}
